<template>
    <div>
        <el-button type="primary" size="mini" plain @click="getData">
            <span class="el-icon-edit-outline">编辑基础信息</span>
        </el-button>
        <el-dialog
            title="楼盘基础信息"
            :visible.sync="showdialog"
            width="600px"
            v-dialogDrag
            append-to-body>

            <el-form :model="form" ref="form" label-width="80px" :inline="false" size="mini">
                <el-form-item label="项目概况">
                    <el-form class="gaikuang-form" label-width="80px" :inline="false" size="mini">
                        <el-form-item label="占地面积">
                            <div class="flex-box">
                                <div class="input-box">
                                    <el-input type="number" v-model="form.floor_space" placeholder="面积，数字类型"></el-input>
                                </div>
                                <span>/㎡</span>
                            </div>
                        </el-form-item>
                        <el-form-item label="建筑面积">
                            <div class="flex-box">
                                <div class="input-box">
                                    <el-input type="number" v-model="form.covered_area" placeholder="面积，数字类型"></el-input>
                                </div>
                                <span>/㎡</span>
                            </div>
                        </el-form-item>
                        <el-form-item label="容积率">
                            <div class="flex-box">
                                <div class="input-box">
                                    <el-input type="number" v-model="form.plot_ratio" placeholder="容积率，数字类型"></el-input>
                                </div>
                            </div>
                        </el-form-item>
                        <el-form-item label="绿化率">
                            <div class="flex-box">
                                <div class="input-box">
                                    <el-input type="number" v-model="form.greening_rate" placeholder="请输入绿化率，数字类型"></el-input>
                                </div>
                                <span>%</span>
                            </div>
                        </el-form-item>
                        <el-form-item label="总户数">
                            <div class="flex-box">
                                <div class="input-box">
                                    <el-input type="number" v-model="form.households" placeholder="总户数，数字类型"></el-input>
                                </div>
                                <span>户</span>
                            </div>
                        </el-form-item>
                    </el-form>
                </el-form-item>
                <el-form-item label="产品类型">
                    <el-input v-model="form.product_type" placeholder="小高层 叠墅"></el-input>
                </el-form-item>
                <el-form-item label="开发商">
                    <el-input v-model="form.developers"></el-input>
                </el-form-item>
                <el-form-item label="物业">
                    <el-input v-model="form.property_management"></el-input>
                </el-form-item>
                <el-form-item label="停车位">
                    <el-input v-model="form.parking_spot" placeholder="车位配比1:1.1"></el-input>
                </el-form-item>
                <el-form-item label="交付标准">
                    <el-select v-model="form.delivery" placeholder="请选择">
                        <el-option
                        v-for="(item, index) in deliverys"
                        :key="index"
                        :label="item"
                        :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="销售状态">
                    <el-select v-model="form.sell" placeholder="请选择">
                        <el-option
                        v-for="(item, index) in sells"
                        :key="index"
                        :label="item"
                        :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="户型面积">
                    <el-row>
                        <el-col :span="11">
                            <div class="flex-box">
                                <el-input type="number" v-model="door_area[0]" @blur="getTotalPrice"></el-input>
                                <span class="danwei">/㎡</span>
                            </div>
                        </el-col>
                        <el-col :span="2">&nbsp;至</el-col>
                        <el-col :span="11">
                            <div class="flex-box">
                                <el-input type="number" v-model="door_area[1]"></el-input>
                                <span class="danwei">/㎡</span>
                            </div>
                        </el-col>
                    </el-row>
                </el-form-item>
                <el-form-item label="均价">
                    <div class="flex-box">
                        <div class="input-box">
                            <el-input type="number" v-model="form.average_price" @blur="getTotalPrice"></el-input>
                        </div>
                        <span class="danwei">/元</span>
                    </div>
                </el-form-item>
                <el-form-item label="总价">
                    <div class="flex-box">
                        <div class="input-box">
                            <el-input type="number" v-model="form.total_price"></el-input>
                        </div>
                        <span class="danwei">万起</span>
                    </div>
                </el-form-item>
                <!-- <el-form-item label="销售动态">
                    <el-input class="textarea" type="textarea" v-model="form.sales_data" placeholder="项目持续验资中，目前样板间已开放。项目首开将提供建面98㎡、120㎡三房小高层，和建面约150㎡、165㎡四房的叠墅（本动态更新于2020年11月30日）"></el-input>
                </el-form-item> -->
                <el-form-item>
                    <el-button type="primary" @click="confirm">保存</el-button>
                    <el-button @click="showdialog = false">取消</el-button>
                </el-form-item>
            </el-form>
            
            
        </el-dialog>
        
    </div>
</template>

<script>
export default {
    data() {
        return {
            showdialog: false,
            form: {
                floor_space: '',
                covered_area: '',
                plot_ratio: '',
                greening_rate: '',
                households: '',
                product_type: '',
                developers: '',
                property_management: '',
                parking_spot: '',
                delivery: '',
                sell: '',
                door_area: [],
                average_price: '',
                total_price: '',
                sales_data: '',
            },
            deliverys: ['', '精装交付', '带装修', '毛坯交付'],
            sells: ['', '在售', '待售', '售馨'],
            door_area: [],
        }
    },
    props: {
        id: {
            type: String,
        },
    },
    methods: {
        getTotalPrice() {
            var price = this.form.average_price;
            var area = this.door_area[0];

            if(price&&area){
                var total = price*area/10000;
                this.form.total_price = total.toFixed(2)
            }

        },
        getData() {
            this.showdialog = true;
            var params = {
                id: this.id,
            }
            this.$api.getProjectById(params).then(
                data=>{
                    if (data.floor_space) this.form.floor_space = data.floor_space;
                    if (data.covered_area) this.form.covered_area = data.covered_area;
                    if (data.plot_ratio) this.form.plot_ratio = data.plot_ratio;
                    if (data.greening_rate) this.form.greening_rate = data.greening_rate;
                    if (data.households) this.form.households = data.households;
                    if (data.product_type) this.form.product_type = data.product_type;
                    if (data.developers) this.form.developers = data.developers;
                    if (data.property_management) this.form.property_management = data.property_management;
                    if (data.parking_spot) this.form.parking_spot = data.parking_spot;
                    if (data.delivery) this.form.delivery = data.delivery;
                    if (data.sell) this.form.sell = data.sell;
                    if (data.door_area) this.door_area = data.door_area;
                    if (data.average_price) this.form.average_price = data.average_price;
                    if (data.total_price) this.form.total_price = data.total_price;
                    if (data.sales_data) this.form.sales_data = data.sales_data;
                }
            )
        },
        confirm() {
            var params = {
                id: this.id,
                floor_space: this.form.floor_space,
                covered_area: this.form.covered_area,
                plot_ratio: this.form.plot_ratio,
                greening_rate: this.form.greening_rate,
                households: this.form.households,
                product_type: this.form.product_type,
                developers: this.form.developers,
                property_management: this.form.property_management,
                parking_spot: this.form.parking_spot,
                delivery: this.form.delivery,
                sell: this.form.sell,
                door_area: JSON.stringify(this.door_area),
                average_price: this.form.average_price,
                total_price: this.form.total_price,
                sales_data: this.form.sales_data,
            };
            this.$api.editProjectBasics(params).then(
                data=>{
                    this.$message.success(data);
                    this.showdialog = false;
                }
            )
        }
    },
}
</script>

<style lang="scss" scoped>
.gaikuang-form{
    ::v-deep .el-form-item--mini.el-form-item{
        margin-bottom: 0;
    }
}
.danwei{
    min-width: 80px;
}
.textarea{
    ::v-deep .el-textarea__inner{
        min-height: 100px!important;
    }
}
</style>